import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { type PropType } from 'vue';

import { type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'LockedFunds',
  props: {
  currency: { type: String, required: true },
  masked: { type: Boolean, default: false },
  precision: { type: [Number, String], required: true },
  value: { type: String, required: true },
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ot_balance = _resolveComponent("ot-balance")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["locked-funds", [`locked-funds--${__props.variant}`]])
  }, [
    _createVNode(_component_i18n_t, {
      keypath: "fundamentals.lockedFunds",
      tag: "span",
      scope: "global"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ot_balance, {
          class: "locked-funds__balance",
          masked: __props.masked,
          precision: __props.precision,
          symbol: __props.currency,
          value: __props.value
        }, null, 8, ["masked", "precision", "symbol", "value"])
      ]),
      _: 1
    })
  ], 2))
}
}

})